import {initSlider} from "./components/slider";
import {initModal} from "./components/modal";
import {initSearch} from "./components/search";
import {initSelect} from "./components/select";
import {initSidebar} from "./components/sidebar";
import {initNavigation} from "./components/navigation";
import {initLightBox} from "./components/lightbox";
import {initAccordion} from "./components/accordion";
import {initMap} from "./components/leaflet";

require("./components/woocommerce");

(function ($) {
    initLightBox();
    initNavigation();
    initSidebar();
    initSelect();
    initSearch();
    initModal();
    initSlider();
    initAccordion();
    initMap();
})(jQuery);